export default process.env.VUE_APP_API_BASE
